import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueSilentbox from 'vue-silentbox'
import VModal from 'vue-js-modal'
import VueCarousel from 'vue-carousel'
import Axios from 'axios'
import VTooltip from 'v-tooltip'
import VueSession from 'vue-session'
import Meta from 'vue-meta'
import VueCookies from 'vue-cookies'
import VueJsonp from 'vue-jsonp'
import OneSignalVue from 'onesignal-vue'
import Vue2Filters from 'vue2-filters'
import JsonExcel from "vue-excel-ultra"

Vue.use(VueJsonp);
Vue.use(VueCookies);
Vue.use(Meta);
Vue.use(VueSession);
Vue.use(OneSignalVue);
Vue.prototype.$http = Axios;
Vue.use(Vue2Filters)

const env = process.env.NODE_ENV || 'production';
if (env === 'development') {
    Vue.prototype.$host = 'http://127.0.0.1:5000';
} else {
    Vue.prototype.$host = 'http://46.254.18.7:5000';
}

import Main from "./layouts/Main";
import Default from "./layouts/Default";
import Login from "./layouts/Login";
import store from './store'

Vue.component('main-layout', Main);
Vue.component('default-layout', Default);
Vue.component('login-layout', Login);

Vue.component("downloadExcel", JsonExcel);

Vue.use(VTooltip);
Vue.use(VueCarousel);
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });
Vue.use(VueSilentbox);
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    // console.log(to, from);

    if (to.matched.some(record => record.meta.requiresAuth)) {
        // if (localStorage.getItem('sale-katris-jwt') == null) {

        // console.log(Vue.prototype.$session.get('jwt'))

        if (Vue.prototype.$session.get('jwt') == null) {
            // alert('!!!')
            next({
                path: '/login',
                params: {nextUrl: to.fullPath}
            })
        } else {
            let session = Vue.prototype.$session.get('user');

            //Проверка прав
            switch (to.matched[0].path) {
                case '/ordersState':
                case '/order/:orderId':
                case '/reorder/:orderId':
                    if (session.newType == 0 || session.accOrders == 1) {
                        next();
                    } else {
                        next({name: 'home'});
                    }
                    break;
                case '/accessoriesOrdering':
                case '/accessoriesOrdering/:new':
                case '/configurator':
                case '/configurator/:id':
                case '/itemsList/:setId/:groupId':
                case '/orderFromCatalog':
                case '/basket':
                    if (session.newType == 0 || session.accKomplect == 1) {
                        next();
                    } else {
                        next({name: 'home'});
                    }
                    break;
                case '/readyMade':
                    if (session.newType == 0 || session.accGP == 1) {
                        next();
                    } else {
                        next({name: 'home'});
                    }
                    break;
                case '/additionalFeatures/paymentsSchedule':
                    if ((session.newType == 0 || session.accPayGrafik == 1) && session.kredit && session.loginId != '2768') {
                        next();
                    } else {
                        next({name: 'home'});
                    }
                    break;
                case '/additionalFeatures/balance':
                    if (session.newType == 0 || session.accBalans == 1) {
                        next();
                    } else {
                        next({name: 'home'});
                    }
                    break;
                case '/additionalFeatures/addNewUser':
                    if (session.newType == 1 && session.parent == 0) {
                        next();
                    } else {
                        next({name: 'home'});
                    }
                    break;
                case '/additionalFeatures/manageUsers':
                    if (session.newType == 1 && session.parent == 0) {
                        next();
                    } else {
                        next({name: 'home'});
                    }
                    break;
                case '/additionalFeatures/parameters':
                    if (session.loginId != 2768 && session.newType == 1) {
                        next();
                    } else {
                        next({name: 'home'});
                    }
                    break;
                default:
                    next();
            }

        }
    } else if (to.matched.some(record => record.meta.guest)) {
        if (Vue.prototype.$session.get('jwt') == null) {
            next();
        } else {
            next({name: 'home'})
        }
    } else {
        next()
    }
});

Vue.prototype.$logout = function() {
    this.$session.destroy();
    document.location.href = '/login'
};

Vue.prototype.$countGlobal = {number: 0, basket: 0, manual: 0, manual2: 0};
Vue.prototype.$added = {state: false};
Vue.prototype.$notificationsGlobal = {emptyNotices: true, waitListLength: 0};

// Vue.prototype.$aiHelper = false;
// Vue.prototype.$loaded = false;

new Vue({
    router,
    render: h => h(App),
    store,

    beforeMount() {
        this.$OneSignal.init({ appId: '670220b0-052f-47dd-a1db-2eee06b16809' });
    }
}).$mount('#app');
